import { render, staticRenderFns } from "./forbiddenZone.vue?vue&type=template&id=36189cda&"
import script from "./forbiddenZone.vue?vue&type=script&lang=js&"
export * from "./forbiddenZone.vue?vue&type=script&lang=js&"
import style0 from "./forbiddenZone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports